import { useAppSelector } from "../../hooks";

export const useAuthenticationState = () => {
	const useIsAuthenticated = () =>
		useAppSelector(({ authentication }) => authentication.isAuthenticated);
	const useProfile = () =>
		useAppSelector(({ authentication }) => authentication.profile);

	const state = {
		isAuthenticated: useIsAuthenticated,
		profile: useProfile
	};

	return {
		state
	};
};
